import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_import_file_hdr_RowClass} from '../../../dbschema/bl_crm_contact_import_file_hdr.model'

export class ContactImportFileContainerModel extends BaseContainerModel {
    bl_crm_contact_import_file_hdr: bl_crm_contact_import_file_hdr_RowClass = new bl_crm_contact_import_file_hdr_RowClass()
  }
